<!-- 查看商品标签 -->
<template>
    <div>
        <div class="search-ctn">
            <div class="search-ctn-left">
                <div class="search-name">标签编码</div>
                <div class="search-item">
                    <el-input size="small" v-model.trim="searchData.LabelCode" placeholder="标签编码"></el-input>
                </div>
                <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
            </div>
        </div>
        <div class="table-ctn">
            <el-table
                :header-cell-style="{ background: '#F2F6FC' }"
                :header-row-style="{height:'36px'}" 
                :row-style="{height:'36px'}"
                v-loading="loading"
                :data="tableData"
                border
                ref="multipleTable"
                height="470px"
                style="width: 100%; margin-bottom: 10px"
            >
                <el-table-column  fixed show-overflow-tooltip width="180" prop="LabelCode" label="标签编码"></el-table-column>
                <el-table-column show-overflow-tooltip width="160" prop="APCode" label="汽配编码"></el-table-column>
                <el-table-column show-overflow-tooltip min-width="200" prop="GoodName" label="配件名称"></el-table-column>
                <el-table-column show-overflow-tooltip width="60" prop="Unit" label="单位"></el-table-column>
                <el-table-column show-overflow-tooltip width="60" prop="PackingSpec" label="数量"></el-table-column>
                <el-table-column show-overflow-tooltip width="120" prop="StorageName" label="存放仓库"></el-table-column>
                <el-table-column show-overflow-tooltip width="120" prop="SpaceName" label="存放仓位"></el-table-column>
                <el-table-column width="80" show-overflow-tooltip label="标签状态">
                    <template slot-scope="scope">{{ scope.row.State | stateHandle }}</template>
                </el-table-column>
                <el-table-column show-overflow-tooltip width="160" prop="CreateTime" label="创建时间"></el-table-column>
                <el-table-column label="操作" width="80px" fixed="right">
                    <template slot-scope="scope">
                        <div class="ops-ctn">
                            <el-button title="重新打印标签" size="mini" type="text" @click="reprintLabel(scope.row)" v-if="!IsIn">重新打印</el-button>
                            <!-- <el-button title="销毁标签" size="mini" type="text" style="color: red" @click="destroyLabel(scope.row)">销毁标签</el-button> -->
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="dialog-pagination-ctn">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="searchData.Page"
                :page-sizes="[10, 20, 30, 40, 50]"
                :page-size="searchData.Limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tableDataLength"
            ></el-pagination>
        </div>
    </div>
</template>
<script>
export default {
    name: '',
    props: { EntpOId: String, EntpGoodsId: String, OrderRsId: String,IsIn:Boolean },
    components: {},
    data() {
        return {
            loading: false,
            searchData: {
                SaleROrderId: '',
                LabelCode: '',
                EntpGoodsId: '',
                OrderRsId: '',
                Page: 1,
                imit: 10
            },
            tableDataLength: 0,
            tableData: []
        };
    },
    filters: {
        stateHandle(value) {
            if (value == 0) {
                return '正常';
            } else if (value == 1) {
                return '已销毁';
            } else if (value == 2) {
                return '已离仓';
            }
        }
    },
    mounted() {
        this.searchData.SaleROrderId = this.EntpOId;
        this.searchData.EntpGoodsId = this.EntpGoodsId;
        this.searchData.OrderRsId = this.OrderRsId;
        this.getTableData();
    },
    methods: {
        resetSearch() {
            this.searchData = {
                LabelCode: '',
                Page: 1,
                Limit: 10
            };
        },
        getTableData() {
            if (this.EntpOId) {
                this.loading = true;
                this.$util
                    .axiosGet({
                        url: '/api/EntpGoodsLabels/GetSReturnGoodsLabels',
                        data: this.searchData
                    })
                    .then(res => {
                        this.loading = false;
                        let data = res.data;
                        if (!data) data = [];
                        this.tableData = data;
                        this.tableDataLength = res.count;
                    });
            } else this.$util.warningMsg('未检测到销售退货订单，请重新操作');
        },
        reprintLabel(row) {
            let that = this;
            if (row) {
                that.$util.elConfirm({
                    content: '确定要重新打印标签吗？',
                    noMsg: true,
                    confirm() {
                        //传到接口调用打印出来
                        that.$util
                            .axiosPost({
                                url: '/api/EntpGoodsLabels/RePrintSReturnGoodsLabels',
                                data: {
                                    LabelCode: row.LabelCode,
                                    LabelId: row.LabelId
                                }
                            })
                            .then(res => {
                                if (res.errcode == 0) that.$util.successMsg('重新打印完成');
                                else that.$util.successMsg(res.errmsg);
                            });
                    }
                });
            }
        },
        destroyLabel(row) {
            let that = this;
            that.$util.elConfirm({
                content: '确定销毁该商品的标签吗？',
                noMsg: true,
                confirm() {
                    //传到接口调用打印出来
                    that.$util
                        .axiosPost({
                            url: '/api/EntpGoodsLabels/DestroyGoodsLabels',
                            data: {
                                LabelCode: row.LabelCode,
                                LabelId: row.LabelId
                            }
                        })
                        .then(res => {
                            if (res.errcode == 0) {
                                that.$util.successMsg('成功销毁标签');
                                that.getTableData();
                            } else that.$util.errorMsg(res.errmsg);
                        });
                }
            });
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.Page = 1;
            this.searchData.Limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.Page = val;
            this.getTableData();
        }
    }
};
</script>
<style lang="less" scoped>
.search-ctn-left {
    margin-bottom: 10px;
    .search-name {
        margin-bottom: 0;
    }
}
</style>
